import React, { useState, useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import history from '~/services/history';

import { Container, Badge, MenuItens, MenuList } from './styles';
import menu from '~/assets/menu@2x.png';

import { signOut } from '~/store/modules/auth/actions';

export default function Menu() {
  const dispatch = useDispatch();
  const ref = useRef(null);

  const [visible, setVisible] = useState(false);

  useEffect(() => {
    function handleClickOutside(event) {
      if (visible && event.target.id === 'menu') return;
      if (ref.current && !ref.current.contains(event.target)) {
        setVisible(false);
      }
    }

    // Bind the event listener
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [visible]);

  function handleToggleVisible() {
    setVisible(!visible);
  }

  function handleSignOut() {
    dispatch(signOut());
  }

  return (
    <Container>
      <Badge onClick={handleToggleVisible}>
        {' '}
        <img id="menu" src={menu} alt="Menu de Opções" />
      </Badge>

      <MenuList ref={ref} visible={visible}>
        <MenuItens>
          <button type="button" onClick={() => history.push('/MeusImoveis')}>
            Meus imóveis
          </button>
        </MenuItens>
        <MenuItens>
          <button type="button" onClick={() => history.push('/MinhaConta')}>
            Minha conta
          </button>
        </MenuItens>
        <MenuItens>
          <button type="button" onClick={() => history.push('/AlterarSenha')}>
            Alterar senha
          </button>
        </MenuItens>
        <MenuItens>
          <button type="button" onClick={handleSignOut}>
            Sair
          </button>
        </MenuItens>
      </MenuList>
    </Container>
  );
}
